<div class="watch-camera-tile" [class.fullscreen]="isFullscreen">
  <!-- Loading State -->
  <div *ngIf="loading" class="tile-state loading-state">
    <div class="spinner-border text-light" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-3">Loading {{ item.name }}...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="tile-state error-state">
    <i class="bi bi-exclamation-triangle-fill error-icon"></i>
    <p class="error-message">{{ cameraName }}</p>
    <small>Unable to load imagery</small>
  </div>

  <!-- Camera/Incident Image -->
  <div *ngIf="!loading && !error" class="tile-content" (dblclick)="toggleFullscreen()">
    <div class="image-container">
      <!-- Current Image -->
      <img 
        *ngIf="currentImageUrl"
        [src]="currentImageUrl" 
        [alt]="cameraName"
        (error)="onImageError()"
        (load)="onImageLoad()"
        [class.slide-out-left]="isTransitioning && transitionDirection === 'forward'"
        [class.slide-out-right]="isTransitioning && transitionDirection === 'backward'"
        class="camera-image">
      
      <!-- Overlay rectangles for detections (incidents only) -->
      <div *ngIf="(item.type === 'incident' || item.type === 'incident-status') && overlays.length > 0 && !isZoomedImage" 
           class="overlay-container">
        <div *ngFor="let overlay of overlays" 
             class="detection-rectangle" 
             [style.left.%]="overlay.x" 
             [style.top.%]="overlay.y" 
             [style.width.%]="overlay.w" 
             [style.height.%]="overlay.h">
          <div class="detection-label">
            {{(overlay.confidence * 100).toFixed(0)}}%
          </div>
        </div>
      </div>
      
      <!-- Next Image (during transition) -->
      <img 
        *ngIf="nextImageUrl && isTransitioning"
        [src]="nextImageUrl" 
        [alt]="cameraName"
        [class.slide-in-right]="transitionDirection === 'forward'"
        [class.slide-in-left]="transitionDirection === 'backward'"
        class="camera-image camera-image-next">
    </div>
    
    <!-- Camera Info Overlay -->
    <div class="tile-info">
      <div class="camera-name">{{ cameraName }}</div>
      <div *ngIf="currentBearing !== undefined" class="camera-bearing">
        {{ currentBearing }}° {{ item.type === 'camera' ? '(rotating)' : '' }}
      </div>
      <div *ngIf="item.type === 'incident'" class="incident-badge">
        <i class="bi bi-exclamation-circle"></i> Incident
      </div>
    </div>

    <!-- Incident Info Overlay (top right) -->
    <div *ngIf="(item.type === 'incident' || item.type === 'incident-status') && incident" class="incident-info">
      <div class="incident-camera-name">{{ incident.site?.name }}</div>
      <a [href]="'/#/fire-foresight/incident/' + incident.incidentId" 
         class="incident-id-link"
         target="_blank"
         title="View incident details">
        Incident #{{ incident.incidentId }}
      </a>
    </div>

    <!-- Navigation Buttons (only for cameras with multiple images) -->
    <div *ngIf="item.type === 'camera' && cameraImages.length > 1" class="nav-buttons">
      <button 
        class="btn-nav btn-nav-left" 
        (click)="navigateToPrevious()"
        title="Previous view">
        <i class="bi bi-chevron-left"></i>
      </button>
      <button 
        class="btn-nav btn-nav-right" 
        (click)="navigateToNext()"
        title="Next view">
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>
  </div>

  <!-- Remove Button (always visible) -->
  <button 
    class="btn-remove" 
    (click)="onRemoveClick()"
    title="Remove from watch view">
    <i class="bi bi-x-lg"></i>
  </button>

  <!-- Fullscreen Exit Button (visible when in fullscreen) -->
  <button 
    *ngIf="isFullscreen"
    class="btn-exit-fullscreen" 
    (click)="exitFullscreen()"
    title="Exit fullscreen">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
